module.exports = __webpack_public_path__ + "static/media/cases_logos_eventos_07.e1825071.jpg";